import { Component, Inject, OnInit, Optional } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { Response } from 'express';
import { RESPONSE } from '@nguniversal/express-engine/tokens';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error500',
  templateUrl: './error500.component.html',
  styleUrls: ['./error500.component.scss']
})
export class Error500Component implements OnInit {

  private response: Response;
  private sourcePage: string | undefined = "";

  constructor(public helpersService: HelpersService,
              private router : Router,
              @Optional() @Inject(RESPONSE) response: any) { 
                this.response = response;
                this.sourcePage = this.router.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
              }

  ngOnInit(): void {
    this.helpersService.setDataLayerError(500, this.sourcePage);
    if (this.response) {
      this.response.status(500);
    }
  }
}
